const initTransitionForTabs = (node) => {
  if (!node) return;
  const tabs = node.querySelectorAll('[data-tab]');
  const active = node.querySelector('[data-tab].-active');
  const indicator = node.querySelector('[data-indicator]');
  
  const updateActive = (element) => {
    indicator.style.transform = `translateX(${element.offsetLeft}px)`;
    indicator.style.setProperty('--width', `${element.offsetWidth}px`);
    indicator.style.transition = '0.25s all ease-in-out';
  };

  if (active) {
    updateActive(active);
    active.classList.remove('-indicator');
  }

  [].forEach.call(tabs, (tab) => {
    tab.addEventListener('click', () => {
      [].forEach.call(tabs, (t) => t.classList.remove('-active'));
      tab.classList.add('-active');
      updateActive(tab);
    });
  });
};

export { initTransitionForTabs };
